export const sortByFirstName = (ContactList) => {
    const sortedList = [...ContactList].sort(function compare(a, b) {
        if (a.firstName.toLowerCase() < b.firstName.toLowerCase()) {
            return -1;
        }
        if (a.firstName.toLowerCase() > b.firstName.toLowerCase()) {
            return 1;
        }
        return 0;
    });
    return sortedList;
}

export const sortByCompanyAndName = (ContactList) => {
    const sortedList = [...ContactList].sort(function compare(a, b) {
        if (a.companyName.toLowerCase() < b.companyName.toLowerCase()) {
            return -1;
        }
        if (a.companyName.toLowerCase() > b.companyName.toLowerCase()) {
            return 1;
        }
        return a.firstName.toLowerCase().localeCompare(b.firstName.toLowerCase());
    });
    return sortedList;
}